import { render, staticRenderFns } from "./IntroductionBranchPage.vue?vue&type=template&id=2c82e03a&"
import script from "./IntroductionBranchPage.vue?vue&type=script&lang=js&"
export * from "./IntroductionBranchPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports